import { render, staticRenderFns } from "./ChangeProfile.vue?vue&type=template&id=770eb8e1&xmlns%3Av-on=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&xmlns%3Av-bind=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./ChangeProfile.vue?vue&type=script&lang=js"
export * from "./ChangeProfile.vue?vue&type=script&lang=js"
import style0 from "./ChangeProfile.vue?vue&type=style&index=0&id=770eb8e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports